if (!customElements.get('ae-brand-directory')) {
  customElements.define('ae-brand-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const grid = this.querySelector('[data-directory-grid]');
      const search = this.querySelector('[data-directory-search]');
      const sort = this.querySelector('[data-directory-sort]');
      if (!grid || !search || !sort) return;
      this.ready = true;
      this.category = 'all';
      const items = Array.from(grid.querySelectorAll('[data-directory-item]'));
      const buttons = Array.from(this.querySelectorAll('[data-directory-category]'));
      const collator = new Intl.Collator('en', { sensitivity: 'base', numeric: true });
      const normalize = value => (value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
      const order = () => {
        const direction = sort.value === 'desc' ? -1 : 1;
        items.sort((a, b) => direction * collator.compare(a.dataset.name, b.dataset.name));
        const fragment = document.createDocumentFragment();
        items.forEach(item => fragment.appendChild(item));
        grid.appendChild(fragment);
      };
      const filter = () => {
        const term = normalize(search.value);
        let visible = 0;
        items.forEach(item => {
          const matches = normalize(item.dataset.name).includes(term) &&
            (this.category === 'all' || (item.dataset.categories || '').split(/\s+/).includes(this.category));
          item.hidden = !matches;
          if (matches) visible++;
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.directoryCategory === this.category)));
        this.querySelector('[data-directory-status]').textContent = this.dataset.countFormat.replace('[visible]', String(visible)).replace('[total]', String(items.length));
        this.querySelector('[data-directory-empty]').hidden = visible > 0;
      };
      search.addEventListener('input', filter);
      sort.addEventListener('change', order);
      buttons.forEach(button => button.addEventListener('click', () => {
        this.category = button.dataset.directoryCategory;
        filter();
      }));
      this.querySelectorAll('[data-directory-reset]').forEach(button => button.addEventListener('click', () => {
        search.value = '';
        this.category = 'all';
        filter();
        search.focus();
      }));
      this.addEventListener('shopify:block:select', () => {
        search.value = '';
        this.category = 'all';
        filter();
      });
      order();
      filter();
      this.querySelector('[data-directory-tools]').hidden = false;
    }
  });
}
